// Phase 1A Step 34 — Landing wordmark + mark.
// Port from handoff/landing-reference/sections.jsx Logo helper.
// Inline SVG matches the brand mark shape (two amber chevrons).

interface LogoProps {
  size?: number;
}

export function Logo({ size = 22 }: LogoProps): JSX.Element {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 32 32" style={{ display: "block" }}>
        <path d="M4 6 L20 6 L28 14 L12 14 Z" fill="#D4A843" />
        <path d="M4 18 L20 18 L28 26 L12 26 Z" fill="#D4A843" opacity="0.55" />
      </svg>
      <span
        className="display"
        style={{
          fontSize: size * 0.95,
          color: "var(--text)",
          letterSpacing: "0.04em",
        }}
      >
        STRIKZA
      </span>
    </span>
  );
}
